// Canonical outlined Schibsted Grotesk Bold (700), from the self-hosted font.
// All wordmark renderers share these letterforms and matching dots.
import { resolveBrand } from "./index.js";

export const CAIRE_DESCRIPTORS = Object.freeze({
  sv: "AI för hemtjänstens verksamhet",
  en: "AI-powered home care operations",
});
export const CAIRE_WORDMARK = Object.freeze({
  viewBox: "0 0 5674 1630",
  baseline: 1603,
  shapes: [
    {
      part: "letters",
      x: 0,
      d: "M629 -26Q459 -26 334.5 43Q210 112 143 239Q76 366 76 541Q76 715 143 842Q210 969 334 1037.5Q458 1106 628 1106Q750 1106 855 1062Q960 1018 1033.5 931.5Q1107 845 1134 717L852 657Q830 772 772 829.5Q714 887 626 887Q505 887 446.5 791Q388 695 388 537Q388 380 446 286.5Q504 193 627 193Q712 193 770.5 244.5Q829 296 856 402L1129 351Q1109 253 1060 181.5Q1011 110 942.5 64.5Q874 19 794 -3.5Q714 -26 629 -26Z",
    },
    {
      part: "letters",
      x: 1200,
      d: "M447 -26Q344 -26 257 10.5Q170 47 117.5 119Q65 191 65 299Q65 415 132 496Q199 577 327 619.5Q455 662 636 662L788 662L770 635L770 697Q770 804 731 856.5Q692 909 602 909Q516 909 470.5 863.5Q425 818 415 734L111 786Q128 876 188.5 948.5Q249 1021 356 1064Q463 1107 619 1107Q762 1107 861 1061.5Q960 1016 1011.5 914Q1063 812 1063 641L1063 274Q1063 240 1072.5 229Q1082 218 1113 218L1162 218L1162 0L1020 0Q903 0 842.5 58.5Q782 117 782 227L782 278L834 258Q821 215 796 166Q771 117 726.5 73.5Q682 30 614 2Q546 -26 447 -26ZM533 178Q603 178 657 210Q711 242 742 306.5Q773 371 773 467L773 490L647 490Q540 490 480.5 462Q421 434 397 393.5Q373 353 373 315Q373 285 387.5 253Q402 221 436.5 199.5Q471 178 533 178Z",
    },
    {
      part: "letters",
      x: 2421,
      d: "M142 0L142 1080L440 1080L440 0Z",
    },
    {
      part: "dot",
      x: 2421,
      d: "M291 1209Q202 1209 148 1263Q94 1317 94 1406Q94 1496 148 1549.5Q202 1603 291 1603Q381 1603 434.5 1549.5Q488 1496 488 1406Q488 1317 434.5 1263Q381 1209 291 1209Z",
    },
    {
      part: "letters",
      x: 2992,
      d: "M141 0L141 1080L429 1080L429 837L417 869Q468 989 561 1047.5Q654 1106 764 1106Q795 1106 827 1101Q859 1096 891 1084L868 830Q803 848 743 848Q694 848 640.5 831Q587 814 541.5 771.5Q496 729 467.5 651.5Q439 574 439 454L439 0Z",
    },
    {
      part: "letters",
      x: 3874,
      d: "M633 -26Q474 -26 347.5 43Q221 112 147.5 239.5Q74 367 74 541Q74 714 146.5 841Q219 968 344.5 1037Q470 1106 631 1106Q720 1106 811.5 1079Q903 1052 980 983.5Q1057 915 1104 792.5Q1151 670 1151 480L265 480L265 650L885 650L854 597Q846 705 814 771Q782 837 733 867Q684 897 623 897Q544 897 491 852Q438 807 411.5 726.5Q385 646 385 540Q385 380 445.5 287Q506 194 631 194Q712 194 770.5 236Q829 278 860 364L1130 295Q1092 183 1015 112Q938 41 838.5 7.5Q739 -26 633 -26Z",
    },
    {
      part: "period",
      x: 5094,
      d: "M291 1209Q202 1209 148 1263Q94 1317 94 1406Q94 1496 148 1549.5Q202 1603 291 1603Q381 1603 434.5 1549.5Q488 1496 488 1406Q488 1317 434.5 1263Q381 1209 291 1209Z",
      y: -1209,
    },
  ],
});

export function renderCaireWordmarkSvg({
  brand = resolveBrand(),
  variant = "standard",
} = {}) {
  const ink = variant === "inverse" ? brand.colors.onAction : brand.colors.ink;
  const dots =
    variant === "monochrome"
      ? ink
      : variant === "inverse"
        ? brand.colors.accent
        : brand.colors.action;
  const paths = CAIRE_WORDMARK.shapes
    .map(
      ({ d, x, y = 0, part }) =>
        `<path data-part="${part}" transform="translate(${x} ${y})" fill="${part === "letters" ? ink : dots}" d="${d}"/>`,
    )
    .join("");
  return `<svg xmlns="http://www.w3.org/2000/svg" viewBox="${CAIRE_WORDMARK.viewBox}" role="img" aria-label="Caire"><g transform="translate(0 ${CAIRE_WORDMARK.baseline}) scale(1 -1)">${paths}</g></svg>`;
}
